var r = {};
export {
  r as __exports
};
//# sourceMappingURL=index.es283.js.map
